import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CTA, Text } from '../../../ui/atoms';
import InputLegend from '../../../ui/atoms/InputLegend';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { MODAL_OPEN } from '../../redux/actions';
import ButtonsBanner from '../../../ui/components/Tutor/ButtonsBanner';
import theme from '../../../ui/theme';
import { CustomBox, InputContainer, Separator, TagsWrapper } from './style';
import { RelatedCourseCards } from '../../../ui/atoms/Modals/ModalRelatedCourses/style';
import TagBadge from '../../../ui/atoms/TagBadge';
import ModalPreviewMedia, {
  ModalPreviewMediaId,
} from '../../../ui/atoms/Modals/ModalPreviewMedia';

const Overview = ({ mediaIsPhone, course, modalOpen }) => {
  const { overview } = course;

  return (
    <div>
      <Text type="h1.5" mb={8}>
        Anagrafica
      </Text>
      <Text type="b3" mb={44}>
        Sezione dedicata ai dati e impostazioni principali del percorso
        formativo che si sta creando.
      </Text>
      <InputContainer>
        <div>
          <InputLegend label="Seleziona l’area tematica" required />
          <Text type="b3">{overview?.category?.name}</Text>
        </div>
        <div>
          <InputLegend label="Seleziona la materia" required />
          <Text type="b3">{overview?.subject?.name}</Text>
        </div>
        <div>
          <InputLegend
            label="Codice percorso formativo"
            tooltipKey="course_code"
          />
          <Text type="b3">{overview?.code}</Text>
        </div>
      </InputContainer>
      <Separator />
      <InputLegend
        label="Rendi visibile il percorso formativo"
        required
        tooltipKey="course_published"
      />
      <Text type="b3">{overview?.published ? 'Visibile' : 'Non visibile'}</Text>
      <Separator />
      <InputContainer>
        <div>
          <InputLegend
            label="Titolo evento"
            required
            tooltipKey="event_title"
          />
          <Text type="b3">{overview?.title}</Text>
        </div>
        <div>
          <InputLegend
            label="Immagine evento"
            required
            tooltipKey="event_cover"
          />
          <div className="d-flex g-16">
            <Text type="b3">{overview?.course_cover?.title}</Text>
            {overview?.course_cover?.url && (
              <CTA
                type="tertiary"
                btnText="Visualizza"
                icon="eye"
                onClick={() =>
                  modalOpen(ModalPreviewMediaId, {
                    url: overview?.course_cover?.url,
                  })
                }
              />
            )}
          </div>
        </div>
        <div>
          <InputLegend
            label="Percentuale di partecipazione"
            required
            tooltipKey="participation_percentage"
          />
          <Text type="b3">
            {`${overview?.participation_percentage?.toString()}%`}
          </Text>
        </div>
      </InputContainer>
      <Separator />
      <Text type="h3" mb={12}>
        TAG
      </Text>{' '}
      <TagsWrapper>
        {overview?.tags?.length > 0 && (
          <>
            {(overview?.tags || []).map((t, i) => (
              <TagBadge key={`added-tag-${i}`} item={t} isActive />
            ))}
          </>
        )}
        {!overview?.tags?.length > 0 && (
          <Text type="b3" color="#646464">
            Nessun TAG aggiunto
          </Text>
        )}
      </TagsWrapper>
      <Separator />
      <CustomBox>
        <Text type="h1.5" mb={8}>
          Panoramica
        </Text>
        <Text type="b3" mb={40}>
          Sezione dedicata al contenuto redazionale del percorso formativo che
          si sta creando. Viene mostrato al discente nel dettaglio corso, sotto
          la voce del tab “Panoramica”
        </Text>
        <InputLegend label="Descrizione" required />
        <Text type="b3" mb={40}>
          {overview?.description}
        </Text>
        <div>
          <InputLegend
            label="Contenuto multimediale"
            tooltipKey="course_panoramic_media"
            type="secondary"
          />
          <div className="d-flex g-16">
            <Text type="b3">{overview?.panoramic_media?.title}</Text>
            {overview?.panoramic_media?.url && (
              <CTA
                type="tertiary"
                btnText="Visualizza"
                icon="eye"
                onClick={() =>
                  modalOpen(ModalPreviewMediaId, {
                    url: overview?.panoramic_media?.url,
                  })
                }
              />
            )}
          </div>
        </div>
        <Separator />
        <InputLegend label="Percorsi formativi correlati" />
        {overview?.related_courses?.length > 0 && (
          <>
            <Text type="b3" mb={24}>
              Hai aggiunto {overview?.related_courses?.length} percorsi
              formativi correlati:
            </Text>
            <RelatedCourseCards>
              {(overview?.related_courses || []).map((rc) => (
                <div className="related-card" key={`relate-course-${rc?.id}`}>
                  <Text type="b4" className="code">
                    {rc?.code}
                  </Text>
                  <Text type="h3" className="ellipsis">
                    {rc?.title}
                  </Text>
                </div>
              ))}
            </RelatedCourseCards>
          </>
        )}
        <div className={mediaIsPhone ? '' : 'd-flex g-24'}>
          {!overview?.related_courses?.length > 0 && (
            <Text type="b3" color="#646464" mt={mediaIsPhone ? 16 : 0}>
              Nessun percorso formativo aggiunto
            </Text>
          )}
        </div>
      </CustomBox>
      {mediaIsPhone && (
        <Text type="b3" className="mt-5" color={theme().colors.fail}>
          * campo obbligatorio
        </Text>
      )}
      <ButtonsBanner hasMandatoryFields nextEnabled />
      <ModalPreviewMedia />
    </div>
  );
};

Overview.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC: state
  course: PropTypes.object,

  // HOC: dispatch
  modalOpen: PropTypes.func,
};

export default connect(
  (state) => {
    const { activeTab, course } = state.tutors;
    return {
      activeTab,
      course,
    };
  },
  (dispatch) => ({
    modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
  })
)(withMediaQueries(Overview));
